export class ApiError extends Error {
    constructor(
        public status: number,
        message: string,
        public data?: unknown
    ) {
        super(message);
        this.name = 'ApiError';
    }

    static fromResponse(response: Response, data?: { message: string; data?: unknown }) {
        const message = data?.message || `HTTP error! status: ${response.status}`;
        return new ApiError(response.status, message, data?.data);
    }

    static isApiError(error: unknown): error is ApiError {
        return error instanceof ApiError;
    }
}

export class ValidationError extends Error {
    constructor(
        message: string,
        public errors: Record<string, string[]>
    ) {
        super(message);
        this.name = 'ValidationError';
    }
}

export class AuthenticationError extends ApiError {
    constructor(message = 'Authentication required') {
        super(401, message);
        this.name = 'AuthenticationError';
    }
}

export class NetworkError extends Error {
    constructor(message = 'Network error occurred') {
        super(message);
        this.name = 'NetworkError';
    }
}

export class NotFoundError extends ApiError {
    constructor(message = 'Resource not found') {
        super(404, message);
        this.name = 'NotFoundError';
    }
}

export class ServerError extends ApiError {
    constructor(message = 'Internal server error') {
        super(500, message);
        this.name = 'ServerError';
    }
}
